import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl, intlShape } from '../../util/reactIntl';
import { isScrollingDisabled } from '../../ducks/UI.duck';
import config from '../../config';
import { twitterPageURL } from '../../util/urlHelpers';
import { StaticPage, TopbarContainer } from '../../containers';
import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  SectionRefundAndArbitrationTop,
  SectionRefundAndArbitrationContent,
  SectionLearnFromPeople,
  Footer,
  ExternalLink,
} from '../../components';

import css from './RefundAndArbitrationPage.module.css';

const RefundAndArbitrationPageComponent = props => {
  const { intl } = props;
  const { siteTwitterHandle, siteFacebookPage } = config;
  const siteTwitterPage = twitterPageURL(siteTwitterHandle);

  // prettier-ignore
  return (
    <StaticPage
      title="Refund And Arbitration | Career Navig8r"
      description='Career Navig8r Refund And Arbitration'
      schema={{
        '@context': 'http://schema.org',
        '@type': 'FaqPage',
        description: 'Career Navig8r Refund And Arbitration',
        name: 'Refund And Arbitration page',
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>
        <LayoutWrapperMain>
          <ul className={css.sections}>
            <li className={css.sectionAboutTop}>
              <div className={css.sectionContentAboutTop}>
                <SectionRefundAndArbitrationTop/>
              </div>
            </li>
            <li className={css.sectionAboutTop}>
              <div className={css.sectionContentAboutMain}>
                <SectionRefundAndArbitrationContent intl={intl} />
              </div>
            </li>
            <li className={css.sectionLearn}>
              <div className={css.sectionContentLearn}>
                <SectionLearnFromPeople/>
              </div>
            </li>
          </ul>
        </LayoutWrapperMain>
        <LayoutWrapperFooter>
          <Footer className={css.footer} />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </StaticPage>
  );
};

const { bool, object } = PropTypes;

RefundAndArbitrationPageComponent.propTypes = {
  scrollingDisabled: bool.isRequired,

  // from withRouter
  history: object.isRequired,
  location: object.isRequired,

  // from injectIntl
  intl: intlShape.isRequired,
};

const mapStateToProps = state => {
  return {
    scrollingDisabled: isScrollingDisabled(state),
  };
};

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const RefundAndArbitrationPage = compose(
  withRouter,
  connect(mapStateToProps),
  injectIntl
)(RefundAndArbitrationPageComponent);

export default RefundAndArbitrationPage;
